module.exports = __webpack_public_path__ + "img/twilight-2.c4093496.jpg";